import { Card, Tag, Button, Row, Col, Form, Space, InputNumber, DatePicker, Select, Table } from 'antd';
import { SearchOutlined, UndoOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from 'react';
import {
	apiGetProviderCheckBalance, apiGetListAccountStatementPostpaid,
	apiGetWalletProviderBalanceTopUpCurrent
} from '../../api';
import { formatCurrency } from '../../utils/string-utils';
import TopUpBalanceDeposit from '../../components/modals/TopUpBalanceDeposit';
import PaymentRevenueForPartner from '../../components/modals/PaymentRevenueForPartner';
import RefundForPartner from '../../components/modals/RefundForPartner';
import { useLoading } from '../../context/LoadingContext';
import moment from 'moment';
import dayjs from 'dayjs';
import defaultParams from '../../assets/constants/default_params';
import { companyAccountAffapi, companyAccountDatasponsor, companyAccountVds, companyAcctionOptions } from '../../assets/constants/default_option';

export default function Dashboard() {
	const [balance, setBalance] = useState<Number>(0)
	const [balanceRefund, setBalanceRefund] = useState<Number>(0)
	const [balanceRevenue, setBalanceRevenue] = useState<Number>(0)
	const [activityHistory, setActivityHistory] = useState<any>({})
	const [parentAccount, setParentAccount] = useState(companyAcctionOptions[0].value)
	const [childAccount, setChildAccount] = useState<string>('')
	const [currentAccount, setCurrentAccount] = useState(companyAcctionOptions[0].value)
	const [currentPage, setCurrentPage] = useState(defaultParams.PAGE)
	const [pageSize, setPageSize] = useState(defaultParams.LIMIT)
	const [search, setSearch] = useState<any>({})
	const [isOpenDeposit, setIsOpenDeposit] = useState(false)
	const [isOpenPaymentRevenue, setIsOpenPaymentRevenue] = useState(false)
	const [isOpenRefundForPartner, setIsOpenRefundForPartner] = useState(false)

	const { setIsLoading } = useLoading()
	const [formSearch] = Form.useForm()

	const status = 'Hoạt động'

	useEffect(() => {
		(async () => {
			setIsLoading(true)
			await fetchBalance()
			await fetchBalanceRefund()
			await fetchBalanceRevenue()
			setIsLoading(false)
		})()
	}, [setIsLoading, currentAccount])

	async function fetchBalance() {
		try {
			switch (currentAccount) {
				case companyAccountDatasponsor:
					const dataSponsorsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountDatasponsor);
					let reqDataSponsors: any = []
					dataSponsorsItems.children.forEach((item: any) => {
						reqDataSponsors.push(apiGetWalletProviderBalanceTopUpCurrent({ cpCode: item.value }))
					})
					const respDataSponsors = await Promise.all(reqDataSponsors)
					const listDataSponsors = respDataSponsors.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalance(listDataSponsors)
					break
				case companyAccountAffapi:
					const affapisItems: any = companyAcctionOptions.find((item) => item.value === companyAccountAffapi);
					let reqAffapis: any = []
					affapisItems.children.forEach((item: any) => {
						reqAffapis.push(apiGetWalletProviderBalanceTopUpCurrent({ cpCode: item.value }))
					})
					const respAffapis = await Promise.all(reqAffapis)
					const listAffapis = respAffapis.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalance(listAffapis)
					break
				case companyAccountVds:
					const vdsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountVds);
					let reqVds: any = []
					vdsItems.children.forEach((item: any) => {
						reqVds.push(apiGetWalletProviderBalanceTopUpCurrent({ cpCode: item.value }))
					})
					const respVds = await Promise.all(reqVds)
					const listVds = respVds.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalance(listVds)
					break
				default:
					const { data } = await apiGetWalletProviderBalanceTopUpCurrent({ cpCode: currentAccount })
					setBalance(data?.balance || 0)
					break
			}
		} catch (error) {
			console.log(error)
			setBalance(0)
		}
	}

	async function fetchBalanceRefund() {
		try {
			switch (currentAccount) {
				case companyAccountDatasponsor:
					const dataSponsorsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountDatasponsor);
					let reqDataSponsors: any = []
					dataSponsorsItems.children.forEach((item: any) => {
						reqDataSponsors.push(apiGetProviderCheckBalance({ cpCode: `${item.value}_refund` }))
					})
					const respDataSponsors = await Promise.all(reqDataSponsors)
					const listDataSponsors = respDataSponsors.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalanceRefund(listDataSponsors)
					break
				case companyAccountAffapi:
					const affapisItems: any = companyAcctionOptions.find((item) => item.value === companyAccountAffapi);
					let reqAffapis: any = []
					affapisItems.children.forEach((item: any) => {
						reqAffapis.push(apiGetProviderCheckBalance({ cpCode: `${item.value}_refund` }))
					})
					const respAffapis = await Promise.all(reqAffapis)
					const listAffapis = respAffapis.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalanceRefund(listAffapis)
					break
				case companyAccountVds:
					const vdsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountVds);
					let reqVds: any = []
					vdsItems.children.forEach((item: any) => {
						reqVds.push(apiGetProviderCheckBalance({ cpCode: `${item.value}_refund` }))
					})
					const respVds = await Promise.all(reqVds)
					const listVds = respVds.reduce((acc: any, item: any) => acc + Number(item.data?.balance || 0), 0)
					setBalanceRefund(listVds)
					break
				default:
					const { data } = await apiGetProviderCheckBalance({ cpCode: `${currentAccount}_refund` });
					setBalanceRefund(data?.balance || 0)
					break
			}
		} catch (error) {
			console.log(error)
			setBalanceRefund(0)
		}
	}

	async function fetchBalanceRevenue() {
		try {
			switch (currentAccount) {
				case companyAccountDatasponsor:
					const dataSponsorsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountDatasponsor);
					let reqDataSponsors: any = []
					dataSponsorsItems.children.forEach((item: any) => {
						reqDataSponsors.push(apiGetProviderCheckBalance({ cpCode: item.value }))
					})
					const respDataSponsors = await Promise.all(reqDataSponsors)
					const listDataSponsors = respDataSponsors.reduce((acc: any, item: any) => acc + Math.abs(item.data?.balance || 0), 0)
					setBalanceRevenue(listDataSponsors)
					break
				case companyAccountAffapi:
					const affapisItems: any = companyAcctionOptions.find((item) => item.value === companyAccountAffapi);
					let reqAffapis: any = []
					affapisItems.children.forEach((item: any) => {
						reqAffapis.push(apiGetProviderCheckBalance({ cpCode: item.value }))
					})
					const respAffapis = await Promise.all(reqAffapis)
					const listAffapis = respAffapis.reduce((acc: any, item: any) => acc + Math.abs(item.data?.balance || 0), 0)
					setBalanceRevenue(listAffapis)
					break
				case companyAccountVds:
					const vdsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountVds);
					let reqVds: any = []
					vdsItems.children.forEach((item: any) => {
						reqVds.push(apiGetProviderCheckBalance({ cpCode: item.value }))
					})
					const respVds = await Promise.all(reqVds)
					const listVds = respVds.reduce((acc: any, item: any) => acc + Math.abs(item.data?.balance || 0), 0)
					setBalanceRevenue(listVds)
					break
				default:
					const { data } = await apiGetProviderCheckBalance({ cpCode: currentAccount })
					setBalanceRevenue(Math.abs(data?.balance) || 0)
					break
			}
		} catch (error) {
			console.log(error)
			setBalanceRevenue(0)
		}
	}

	const fetchActivityHistory = useCallback(async () => {
		try {
			setIsLoading(true)
			switch (currentAccount) {
				case companyAccountDatasponsor:
					const dataSponsorsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountDatasponsor);
					let reqDataSponsors: any = []
					dataSponsorsItems.children.forEach((item: any) => {
						reqDataSponsors.push(apiGetListAccountStatementPostpaid({
							cpCode: item.value,
							page: currentPage,
							size: pageSize,
							year: search.year,
							month: search.month,
							day: search.day,
						}))
					})
					const respDataSponsors = await Promise.all(reqDataSponsors)
					const listDataSponsors = respDataSponsors.map((item: any) => [...item.data.data]).flat()
					const dataSponsor = listDataSponsors
						.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
						.splice(0, 10)
					setActivityHistory({
						data: dataSponsor,
						total: dataSponsor.length,
					})
					break
				case companyAccountAffapi:
					const affapisItems: any = companyAcctionOptions.find((item) => item.value === companyAccountAffapi);
					let reqAffapis: any = []
					affapisItems.children.forEach((item: any) => {
						reqAffapis.push(apiGetListAccountStatementPostpaid({
							cpCode: item.value,
							page: currentPage,
							size: pageSize,
							year: search.year,
							month: search.month,
							day: search.day,
						}))
					})
					const respAffapis = await Promise.all(reqAffapis)
					const listAffapis = respAffapis.map((item: any) => [...item.data.data]).flat()
					const affapi = listAffapis
						.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
						.splice(0, 10)
					setActivityHistory({
						data: affapi,
						total: listAffapis.length,
					})
					break
				case companyAccountVds:
					const vdsItems: any = companyAcctionOptions.find((item) => item.value === companyAccountVds);
					let reqVds: any = []
					vdsItems.children.forEach((item: any) => {
						reqVds.push(apiGetListAccountStatementPostpaid({
							cpCode: item.value,
							page: currentPage,
							size: pageSize,
							year: search.year,
							month: search.month,
							day: search.day,
						}))
					})
					const respVds = await Promise.all(reqVds)
					const listVds = respVds.map((item: any) => [...item.data.data]).flat()
					const vds = listVds
						.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
						.splice(0, 10)
					setActivityHistory({
						data: vds,
						total: vds.length,
					})
					break
				default:
					const { data } = await apiGetListAccountStatementPostpaid({
						cpCode: currentAccount,
						page: currentPage,
						size: pageSize,
						year: search.year,
						month: search.month,
						day: search.day,
					})
					setActivityHistory(data)
					break
			}
		} catch (error) {
			console.log(error)
		} finally {
			setIsLoading(false)
		}
	}, [currentAccount, currentPage, pageSize, search])

	useEffect(() => {
		fetchActivityHistory()
	}, [fetchActivityHistory])

	const closeDeposit = async (requireSync?: boolean) => {
		setIsOpenDeposit(false)
		if (requireSync) {
			await fetchBalance()
			fetchActivityHistory()
		}
	}
	const closePaymentRevenue = async (requireSync?: boolean) => {
		setIsOpenPaymentRevenue(false)
		if (requireSync) {
			await fetchBalanceRevenue()
			fetchActivityHistory()
		}
	}
	const closeRefundForPartner = async (requireSync?: boolean) => {
		setIsOpenRefundForPartner(false)
		if (requireSync) {
			await fetchBalanceRefund()
		}
	}

	const depositEvent = () => setIsOpenDeposit(true)
	const revenuePaymentEvent = () => setIsOpenPaymentRevenue(true)
	const refundToPartners = () => setIsOpenRefundForPartner(true)

	const formatMoney = (money: Number) => money === 0 ? "N/A" : formatCurrency(Number(money));

	const handleSearch = (values: any) => {
		const date = dayjs(values.date)
		setSearch({
			year: date?.year(),
			month: date?.month() + 1,
			day: values.day || null,
		})
	}

	const handleClearSearch = () => {
		formSearch.resetFields()
		setSearch({})
	}

	const handleParentAccountChange = (value: string) => {
		setParentAccount(value)
		setChildAccount('')
		setCurrentAccount(value)
	}

	const handleChildAccountChange = (value: string) => {
		setChildAccount(value)
		setCurrentAccount(value)
	}

	const getChildOptions = () => {
		const parent = companyAcctionOptions.find(item => item.value === parentAccount)
		return parent?.children || []
	}


	return (
		<div>
			<div style={{ display: 'flex' }}>
				<TopUpBalanceDeposit
					isModalVisible={isOpenDeposit}
					onClose={closeDeposit}
					cpCode={currentAccount}
					isProvider={true}
				/>
				<PaymentRevenueForPartner
					isModalVisible={isOpenPaymentRevenue}
					onClose={closePaymentRevenue}
					cpCode={currentAccount}
					isProvider={true}
				/>
				<RefundForPartner
					isModalVisible={isOpenRefundForPartner}
					onClose={closeRefundForPartner}
					cpCode={currentAccount}
					isProvider={true}
				/>
				<div style={{ flex: 1 }}>
					<Card title={
						<div style={{ display: 'flex', alignItems: 'center', gap: 20, margin: 20 }}>
							<div>Ví tiền: </div>
							<Select
								style={{ width: 200 }}
								placeholder="Chọn loại ví"
								value={parentAccount}
								onChange={handleParentAccountChange}
								options={companyAcctionOptions.map(item => ({
									label: item.label,
									value: item.value
								}))}
							/>
							{getChildOptions().length > 0 && (
								<Select
									style={{ width: 200 }}
									placeholder="Chọn tài khoản"
									value={childAccount || undefined}
									onChange={handleChildAccountChange}
									allowClear
									options={getChildOptions().map((child: any) => ({
										label: child.title,
										value: child.value
									}))}
								/>
							)}
						</div>
					}>
						<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
							<div style={{ flex: 1 }}>
								<Row gutter={16}>
									<Col span={8}>
										<Card title="Số dư">
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
												<p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balance)}</p>
											</div>
										</Card>
									</Col>
									<Col span={8}>
										<Card title="Doanh thu">
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
												<p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balanceRevenue)}</p>
											</div>
										</Card>
									</Col>
									<Col span={8}>
										<Card title="Số tiền hoàn trong tháng">
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
												<p style={{ fontSize: 16, fontWeight: 'bold' }}>{formatMoney(balanceRefund)}</p>
											</div>
										</Card>
									</Col>
								</Row>
							</div>
							{currentAccount !== companyAccountDatasponsor && currentAccount !== companyAccountAffapi && currentAccount !== companyAccountVds && (
								<div style={{ width: 200, margin: '0 30px' }}>
									<div style={{ marginBottom: 10 }}>
										Trạng thái: <Tag color={status === 'Hoạt động' ? 'green' : 'red'}>{status}</Tag>
									</div>
									<Button type="primary" block style={{ marginBottom: 16 }} onClick={depositEvent}>Nạp tiền</Button>
									<Button type="dashed" block style={{ marginBottom: 16 }} onClick={revenuePaymentEvent}>Thanh toán doanh thu</Button>
									<Button type="link" block onClick={refundToPartners}>Hoàn tiền cho đối tác</Button>
								</div>
							)}
						</div>
					</Card>
				</div>
			</div>
			<div>
				<Card title="Lịch sử hoạt động" style={{ marginTop: 10 }}>
					{/* Search Filter Section */}
					<div style={{
						backgroundColor: '#fafafa',
						padding: '16px',
						borderRadius: '8px',
						marginBottom: '16px',
						border: '1px solid #f0f0f0'
					}}>
						<Form form={formSearch} onFinish={handleSearch} layout='horizontal'>
							<Row gutter={16} align="middle">
								<Col>
									<Form.Item name="date" label="Tháng" style={{ marginBottom: 0 }}>
										<DatePicker
											format="YYYY-MM"
											picker="month"
											style={{ width: 180 }}
										/>
									</Form.Item>
								</Col>
								<Col>
									<Form.Item name="day" label="Ngày" style={{ marginBottom: 0 }}>
										<InputNumber min={1} max={31} style={{ width: 100 }} />
									</Form.Item>
								</Col>
								<Col>
									<Space>
										<Button type='primary' htmlType="submit" icon={<SearchOutlined />}>Tìm kiếm</Button>
										<Button onClick={handleClearSearch} icon={<UndoOutlined />}>Xóa</Button>
									</Space>
								</Col>
							</Row>
						</Form>
					</div>

					{/* Summary Stats */}
					<Row gutter={16} style={{ marginBottom: 16 }}>
						<Col span={8}>
							<div style={{
								padding: '12px 16px',
								backgroundColor: '#f6ffed',
								borderRadius: '8px',
								border: '1px solid #b7eb8f'
							}}>
								<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Tổng nạp tiền</div>
								<div style={{ fontSize: 20, fontWeight: 'bold', color: '#52c41a' }}>
									{formatCurrency(activityHistory.data?.reduce((sum: any, value: any) => {
										if (value.type === 2) {
											sum += Number(value.credit || 0)
										}
										return sum
									}, 0) || 0)}
								</div>
							</div>
						</Col>
						<Col span={8}>
							<div style={{
								padding: '12px 16px',
								backgroundColor: '#fff1f0',
								borderRadius: '8px',
								border: '1px solid #ffccc7'
							}}>
								<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Tổng thanh toán</div>
								<div style={{ fontSize: 20, fontWeight: 'bold', color: '#ff4d4f' }}>
									{formatCurrency(activityHistory.data?.reduce((sum: any, value: any) => {
										if (value.type === 3) {
											sum += Number(value.debit || 0)
										}
										return sum
									}, 0) || 0)}
								</div>
							</div>
						</Col>
						<Col span={8}>
							<div style={{
								padding: '12px 16px',
								backgroundColor: '#e6f7ff',
								borderRadius: '8px',
								border: '1px solid #91d5ff'
							}}>
								<div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Tổng giao dịch</div>
								<div style={{ fontSize: 20, fontWeight: 'bold', color: '#1890ff' }}>
									{activityHistory.total || 0}
								</div>
							</div>
						</Col>
					</Row>

					{/* Transaction Table */}
					<Table
						dataSource={activityHistory.data || []}
						rowKey={(record, index) => index?.toString() || '0'}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							total: activityHistory.total,
							showSizeChanger: true,
							onChange: (page, size) => {
								setCurrentPage(page);
								if (size !== pageSize) setPageSize(size);
							},
							showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} / ${total} giao dịch`,
						}}
						locale={{
							emptyText: (
								<div style={{
									textAlign: 'center',
									padding: '40px 20px',
									color: '#bfbfbf',
								}}>
									<div style={{ fontSize: 16, fontWeight: 500 }}>Không có giao dịch nào</div>
									<div style={{ fontSize: 14, marginTop: 8 }}>Chưa có lịch sử giao dịch trong thời gian này</div>
								</div>
							)
						}}
						columns={[
							{
								title: 'STT',
								key: 'index',
								width: 60,
								align: 'center',
								render: (_: any, __: any, index: number) => (
									<div>
										{index + 1}
									</div>
								),
							},
							{
								title: 'Loại giao dịch',
								key: 'type',
								width: 200,
								render: (record: any) => (
									<div>
										<Tag color={record.type === 2 ? 'green' : 'red'} style={{ fontSize: 13 }}>
											{record.type === 2 ? 'Nạp tiền' : 'Thanh toán'}
										</Tag>
										<Tag color='orange'>Hoàn thành</Tag>
									</div>
								),
							},
							{
								title: 'Thời gian',
								key: 'createdAt',
								width: 180,
								render: (record: any) => (
									<div style={{ fontSize: 13, fontWeight: 500 }}>
										{moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss')}
									</div>
								),
							},
							{
								title: 'Mã công ty',
								key: 'cpCode',
								width: 150,
								render: () => (
									<div style={{ fontSize: 13 }}>
										{currentAccount}
									</div>
								),
							},
							{
								title: 'Mô tả',
								key: 'description',
								ellipsis: true,
								render: (record: any) => (
									<div style={{ fontSize: 13, color: '#595959' }}>
										{record.description || '-'}
									</div>
								),
							},
							{
								title: 'Số tiền',
								key: 'amount',
								width: 150,
								align: 'right',
								render: (record: any) => (
									<div style={{
										fontSize: 16,
										fontWeight: 'bold',
										color: record.type === 2 ? '#52c41a' : '#ff4d4f'
									}}>
										{record.type === 2
											? `+${formatCurrency(record.credit)}`
											: `-${formatCurrency(record.debit)}`
										}
									</div>
								),
							},
						]}
					/>
				</Card>
			</div>
		</div>
	);
};
